var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-root"},[_c('v-tooltip',{attrs:{"bottom":""}},[_c('div',{staticClass:"label",class:_vm.label,attrs:{"slot":"activator"},slot:"activator"},[_vm._v(_vm._s(_vm.label))]),_c('span',[_vm._v(_vm._s(_vm.tooltip))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }